const LOCATION_SMART_TIMEOUT = 1e4;
export {
  LOCATION_SMART_TIMEOUT
};
